"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniswapV2Connector = void 0;
const UniswapV2Connector_1 = __importDefault(require("../../abis/teleswap/UniswapV2Connector"));
const contract_base_1 = __importDefault(require("../contract-base"));
class UniswapV2Connector extends contract_base_1.default {
    constructor(connectionConfig, contractAddress) {
        super(connectionConfig, contractAddress, UniswapV2Connector_1.default);
    }
    isPathValid(path) {
        return this.contract.methods.isPathValid(path).call();
    }
}
exports.UniswapV2Connector = UniswapV2Connector;
exports.default = UniswapV2Connector;
//# sourceMappingURL=uniswap-v2-connector-interface.js.map